module.exports = __webpack_public_path__ + "img/004-startup.9bb15c41.svg";